if (import.meta.env.PROD) {
    import('./theme-assets');
}

import 'jquery';
import 'bootstrap';

import AvLazyloadImages from "./components/av-lazyload-images";
import AvSmoothScroll from "./components/av-smooth-scroll";
import Navbar from './components/navbar';
import AvScrollingBox from './components/av-scrolling-box';
import AvDatePicker from './components/av-date-picker';
import AvParallaxScrolling from './components/av-parallax-scrolling';
import AvOurStore from './components/av-our-store';
import AvHomePromotion from './components/av-home-promotion';


class App {
    constructor() {
        this.init();
    }

    init() {
        new AvLazyloadImages();
        new AvSmoothScroll();
        new Navbar();
        new AvScrollingBox();
        new AvDatePicker();
        new AvParallaxScrolling();
        new AvOurStore();
        new AvHomePromotion();
    }
}

new App();
